import React, { useEffect, useState } from 'react';
import { Direction, ImageUploadErrType, ReduxState, Response } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import './changePassword.style.scss';
import { API } from 'data';
import { toast } from 'react-toastify';
import { post } from 'scripts/api';

type props = ConnectedProps<typeof connector> & { hide: (e: boolean) => void };
const ChangePassword: React.FC<props> = function (props: props) {
    const lang = props.lang.profile.changePassword;
    const [oldPass, setOldPass] = useState<string>();
    const [newPass, setNewPass] = useState<string>();
    const [re_newPass, setRe_newPass] = useState<string>();
    const [isSaved, setIsSaved] = useState(false);
    const history = useHistory<any>();

    useEffect(() => {
        props.hide(true);
        return () => props.hide(false);
    });

    function onClickHandler() {
        if (oldPass && newPass && re_newPass) {
            if (newPass === re_newPass) {
                const body = {
                    old_password: oldPass,
                    new_password: newPass,
                };
                setIsSaved(true);
                return new Promise((resolve) =>
                    post(API.dashboard.profile.changePassword, body)
                        .then(() => toast.success(lang.success))
                        .catch((res) => {
                            if (res.status >= 500) toast.error(props.lang.serverErr);
                            else if (res.status >= 400) toast.error(lang.error);
                            else toast.error(props.lang.unknownErr);
                        })
                        .finally(() => {
                            setIsSaved(false);
                            resolve(true);
                        }),
                );
            }
        }
    }

    return (
        <div className="kiosk-change-password">
            <div className="header">
                <i onClick={() => history.goBack()} className="material-icons">
                    arrow_forward
                </i>
                <p className="header-text">{lang.changePassword}</p>
            </div>
            <div className="content">
                <div className="items">
                    <p>{lang.oldPass}</p>
                    <OutlinedInput
                        id="outlined-adornment-weight"
                        value={oldPass}
                        type="password"
                        dir={Direction.rtl}
                        autoComplete="new-password"
                        placeholder={lang.inputPH}
                        onChange={(e) => setOldPass(e.target.value)}
                        className="text"
                    />
                </div>
                <div className="items">
                    <p>{lang.newPass}</p>
                    <OutlinedInput
                        id="outlined-adornment-weight"
                        value={newPass}
                        type="password"
                        dir={Direction.rtl}
                        autoComplete="new-password"
                        onChange={(e) => setNewPass(e.target.value)}
                        className="text"
                        placeholder={lang.inputPH}
                    />
                </div>
                <div className="items">
                    <p>{lang.re_oldPass}</p>
                    <OutlinedInput
                        disabled={!newPass}
                        id="outlined-adornment-weight"
                        value={re_newPass}
                        type="password"
                        dir={Direction.rtl}
                        autoComplete="new-password"
                        onChange={(e) => setRe_newPass(e.target.value)}
                        className="text"
                        error={newPass !== re_newPass}
                        placeholder={lang.inputPH}
                    />
                </div>
                <div className="last-line">
                    <Button
                        onClick={onClickHandler}
                        className="save"
                        variant="contained"
                        color="primary"
                        disabled={!oldPass || !newPass || !re_newPass || re_newPass !== newPass}
                    >
                        {!isSaved ? lang.save : <CircularProgress className="spinner" />}
                    </Button>
                </div>
            </div>
        </div>
    );
};
const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    lang: state.lang,
    userData: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(ChangePassword);
